import { Phone, Mail, MapPin } from "lucide-react";
import { BRAND } from "@/lib/brand";
import WhatsappIcon from "@/components/WhatsappIcon";

export default function Contact() {
  const waUrl = `https://wa.me/${BRAND.whatsappRaw}?text=${encodeURIComponent(
    "Hi MHJ Prestige Transport — I'd like a quote."
  )}`;
  return (
    <section
      id="contact"
      data-testid="contact-section"
      className="relative bg-[#0A0A0A] py-24 md:py-32 border-t border-white/5"
    >
      <div className="max-w-[1500px] mx-auto px-6 md:px-12">
        <div className="grid lg:grid-cols-12 gap-10">
          <div className="lg:col-span-5">
            <div className="flex items-center gap-3 text-[11px] tracking-[0.3em] uppercase text-[#E60000] font-bold mb-6">
              <span className="w-8 h-px bg-[#E60000]" />
              Contact · 07
            </div>
            <h2 className="font-display font-extrabold text-white text-4xl sm:text-5xl lg:text-6xl tracking-tight leading-[1.0]">
              Need us
              <br />
              <span className="text-stroke">now?</span>
            </h2>
            <p className="mt-6 text-zinc-400 text-base lg:text-lg leading-relaxed max-w-md">
              The fastest way to reach us is on the phone — day or night. For
              quotes and non-urgent enquiries, email or use the quote form.
            </p>
          </div>

          <div className="lg:col-span-7 grid grid-cols-1 sm:grid-cols-2 gap-px bg-white/10 border border-white/10">
            <ContactBlock
              icon={<Phone className="w-5 h-5" />}
              label="Phone — 24/7"
              value={BRAND.phone}
              href={`tel:${BRAND.phoneRaw}`}
              testId="contact-phone"
            />
            <ContactBlock
              icon={<WhatsappIcon className="w-5 h-5" />}
              label="WhatsApp"
              value={BRAND.phone}
              href={waUrl}
              external
              testId="contact-whatsapp"
            />
            <ContactBlock
              icon={<Mail className="w-5 h-5" />}
              label="Email"
              value={BRAND.email}
              href={`mailto:${BRAND.email}`}
              testId="contact-email"
            />
            <ContactBlock
              icon={<MapPin className="w-5 h-5" />}
              label="Based in"
              value={BRAND.location}
              testId="contact-location"
            />
          </div>
        </div>
      </div>
    </section>
  );
}

function ContactBlock({ icon, label, value, href, external, testId }) {
  const Wrapper = href ? "a" : "div";
  const extra = external
    ? { target: "_blank", rel: "noopener noreferrer" }
    : {};
  return (
    <Wrapper
      href={href}
      data-testid={testId}
      {...extra}
      className="bg-[#050505] p-8 lg:p-10 flex flex-col gap-4 group hover:bg-[#0F0F0F] transition-colors"
    >
      <div className="flex items-center justify-between">
        <div className="border border-white/15 p-3 text-[#E60000] group-hover:border-[#E60000] transition-colors">
          {icon}
        </div>
        <span className="text-[10px] tracking-[0.3em] uppercase text-zinc-500 font-bold">
          {label}
        </span>
      </div>
      <div className="font-display text-white text-xl lg:text-2xl font-bold tracking-tight break-words">
        {value}
      </div>
    </Wrapper>
  );
}
